import { Suspense } from 'react';
import { MyReviewsClient } from './my-reviews-client';

export default function MyReviewsPage() {
  return (
    <Suspense fallback={null}>
      <MyReviewsClient />
    </Suspense>
  );
}
